import { z } from "zod"

export const ModifierSchema = z
  .number()
  .gte(1, "Margin should be higher than 0%")
  .lte(1.2, "Margin should be lower than 20%")
